// extracted by mini-css-extract-plugin
export var container = "_nk-0";
export var dotAnimation = "_nk-2";
export var dotsLoading = "_nk-1";